import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'rfr-button',
  templateUrl: './rfr-button.component.html',
  styleUrls: ['./rfr-button.component.scss'],
})
export class RfrButtonComponent {
  @Input() class: string = '';
  @Input() style: string = '';
  @Input() size: 'small' | 'large' | 'default' = 'default';
  @Input() variant: '' | 'outline' | 'clear' | 'solid' = 'solid';
  @Input() type: 'button' | 'submit' = 'submit';
  @Input() color = ''; // 'primary' | 'success' | 'danger' | 'tertiary' = '';
  @Input() expand: 'block' | 'full' = 'block'

  @Output() click: EventEmitter<any> = new EventEmitter();
  btClasses: string = 'btn';
}
